import React from "react";

import Header from "../header/Header";
import Footer from "../footer/Footer";

export default function Layout({ children }) {
  return (
    <div style={{ paddingTop: "90px" }}>
      <Header />
      {children}
      <Footer />
    </div>
  );
}
